import React, { FC } from 'react'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'

type Props = {
  text: string
  enabled: boolean
  onChange?: (newValue: boolean) => void
  className?: string
}
export const ToggleWithTxt: FC<Props> = ({ text, enabled, onChange, className }) => {
  return (
    <div className={className}>
      <div className="tw-centering tw-w-fit">
        <Toggle enabled={enabled} onChange={onChange} />
        <Txt className="tw-font-bold tw-ml-s-2">{text}</Txt>
      </div>
    </div>
  )
}
